module.exports = __webpack_public_path__ + "img/clemas_bornes_y_optoacopladores.f87e2158.jpg";